import React from 'react';
import { BrandButton as Button, SearchableSelect } from "@/components";

/**
 * Card component for reopening surveys
 * Creates new INSTANCES of an existing survey (same survey ID)
 */
export default function ReopenSurveyCard({
  publishedSurveys,
  selectedSurveyId,
  onSurveyChange,
  onReopenClick,
  loading
}) {
  return (
    <div className="col-md-6 mb-4">
      <div className="card h-100">
        <div className="card-body">
          <h4 className="card-title" style={{ color: "#F16D09" }}>Publish Extra Instances</h4>
          <p className="card-text">
            Create new INSTANCES of an existing survey after it's been launched or even closed  e.g.  for members who missed it.
          </p>
          <div className="alert alert-sm alert-warning" style={{ fontSize: '0.9rem' }}>
            Note: This does NOT create a new survey - data will be part of the original survey's results.
          </div>
          
          <div className="mb-3">
            <label className="form-label ">Select Survey to Reopen and the publish dialogue will open:</label>
            <SearchableSelect
              options={[...publishedSurveys].sort((a, b) => a.title.localeCompare(b.title))}
              value={selectedSurveyId || ''}
              onChange={(surveyId) => onSurveyChange(surveyId || "")}
              placeholder="Search or select..."
              getLabel={(survey) => survey.title}
              getValue={(survey) => survey.id}
              disabled={loading}
            />
          </div>
          
          <Button 
            onClick={onReopenClick}
            disabled={!selectedSurveyId || loading}
            variant="success" style={{ width: "100%" }}
          >
            Publish
          </Button>
        </div>
      </div>
    </div>
  );
}
